import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AuthContext";

/**
 * AdminRoute — wraps admin-only pages. Redirects non-admins to /login.
 */
export default function ProtectedRoute({ children }) {
    const { admin } = useAdminAuth();
    const location = useLocation();

    if (admin === null) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="font-poetic text-[#9a958a] text-lg">a moment of stillness…</div>
            </div>
        );
    }
    if (!admin) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}
